import { render, staticRenderFns } from "./bank.vue?vue&type=template&id=5430f9d2&"
import script from "./bank.vue?vue&type=script&lang=ts&"
export * from "./bank.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports